import styled from '@emotion/styled'
import { mq } from '../../../helpers'
import { gsColors as c } from '../../../styles/Variables'

export const PackagesWrapper = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${c.coral};
  overflow-x: hidden;

  .faq-wrapper {
    padding: 50px 20px;
    width: 100vw;
    background-color: ${c.white};
  }

  .banner {
    max-width: 1440px;
    width: 100%;
    background-size: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    height: 500px;
    background-repeat: no-repeat;
    background-image: url('${props => props.bannerImagePath || '/images/curateur_banner.jpg'}');

    ${mq('max', '900px')} {
      height: 550px;
      ${props => props.bannerMobileImagePath && `background-image: url('${props.bannerMobileImagePath}');`}
    }
  }

  .content {
    max-width: 1440px;
    width: 80%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;

    .curateur-header {
      margin-top: 3rem;
      width: 80%;

    }

    ${mq('max', '768px')} {
      width: 90%;
    }

    .subtitle {
      max-width: 650px;
    }

    .hand-img {
      position: absolute;
      left: 0;
      top: ${props => (props.banner ? '110px' : '70px')};

      ${mq('max', '768px')} {
        transform: scale(0.75) translateX(-100px) translateY(-55px);
      }

      ${mq('min', '1650px')} {
        transform: scale(1.5) translate(50px, 58px);
      }
    }

    .packages-content {
      margin-top: 3rem;
      width: 80%;
      display: flex;
      flex-direction: column;

      h1 {
        font-size: 62px !important;
      }

      ${mq('max', '768px')} {
        width: 100%;
        // margin-top: 0;
      }

      ${mq('min', '1650px')} {
        align-items: center;
      }
    }

    .package-steps {
      .step-1 {
        padding: 50px 0;


        ${mq('max', '768px')} {
          padding: 20px 0;
        }
      }

      .step-2 {
        &:focus {
          outline: none;
        }
      }
    }
  }

  .packages-container {
    margin: 20px 0;

    .package-card {
      max-width: 500px;
      max-height: fit-content;
      margin: 10px 0;
      padding: 20px;
      display: flex;
      flex-wrap: wrap;
      background-color: ${c.white};
      box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);

      ${mq('max', '768px')} {
        max-width: 100%;
      }

      .card-content {
        flex: 1;
        p {
          max-width: 300px;
        }

        display: flex;
        flex-direction: column;

        ${mq('max', '768px')} {
          flex: 1;
        }

        ${mq('max', '550px')} {
          flex-basis: 100%;
          p {
            max-width: 100%;
          }
        }
      }

      .card-cta {
        display: flex;
        justify-content: flex-end;
        align-self: center;

        ${mq('max', '550px')} {
          margin-top: 15px;
        }

        button {
          width: 100%;
          min-width: 0;
        }
      }
    }
  }
`
